export default {
  title: 'Media',
  sections: {
    main: {
      fields: {
        value: {
          title1: 'Media',
          text1: 'Welcome to our media section! Here you will find all the essential information and materials for your coverage of our company. We appreciate your interest and are available for any inquiries at any time.',
          title2: 'Press Releases',
          text2: 'In this section, you will find our current and archived press releases. You can download the texts and accompanying images, logos, and infographics for your coverage.',
          buttonLabel1: 'Press Releases',
          buttonLink1: '/en/blog/category/press',
          title3: 'Image and Logo Material',
          text3: 'We provide you with a selection of high-resolution images and logos that you can use for your editorial coverage of our company. Please note our terms of use for the utilization of these materials.',
          buttonLabel2: 'To image and logo materials',
          buttonLink2: 'https://drive.google.com/drive/u/0/folders/11a7xT-MEqGzzOoDc3XjYgQnDLmyM6wTh',
          title4: 'Media Articles and Contributions',
          text4: 'Discover a collection of articles and contributions about our company that have appeared in various media outlets. Use the search and filter function to specifically search for topics, media, or time period.',
          buttonLabel3: 'To media collection',
          buttonLink3: 'https://drive.google.com/drive/u/0/folders/11a7xT-MEqGzzOoDc3XjYgQnDLmyM6wTh',
          title5: 'Media Contact',
          text5: 'For further information or inquiries, our media contacts are available to you. Please do not hesitate to reach out - we look forward to assisting you.',
          memberName: 'Marco Quinter',
          memberNumber: '+41 (0) 79 402 91 11',
          memberEmail: 'marco.quinter@seu.ch',
          text6: 'We thank you for your interest in our company and look forward to a successful collaboration.',
        },
      }
    }
  }
}
